<ng-container>
  <div
    class="star"
    [ngClass]="{'hover' : star.isHovered}"
    (mouseover)="onHover(index+1)"
    (mouseout)="onHoverOut()"
    *ngFor='let star of starArray; let index = index'
  >
    <input
      type="radio"
      class="sr-only"
      id="star-{{star.id}}"
      [checked]="star.isSelected || star.isHovered">
    <label for="star-{{star.id}}" (click)="onSelected(index+1)">
      {{index + 1}}
    </label>
  </div>
  <div class="star-status">
    {{ message }}
  </div>
</ng-container>

